import React from 'react';
// Images
import GalleryImage from '../../assets/images/main/miss-dominatrixa-elite-dominatrix-with-masked-slave.webp';
// Constants
import { CompanyName } from '../../utils/Constants';

function SectionTwo() {
  return (
    <section className='grid'>
      <div className='grid lg:grid-cols-[2fr_1fr] lg:container lg:mx-auto gap-y-4 gap-x-6 px-6 sm:px-16 xl:gap-x-10 md:px-16 lg:px-10'>
        {/* Article */}
        <article className='grid gap-4 pt-2'>
          {/* Header */}
          <section className='grid lg:grid-cols-reg text-center lg:text-left w-full lg:gap-x-6 border-b-2 border-solid border-colour3 dark:border-colour3'>
            <div className='hidden lg:grid items-center'>
              <h3 className='text-3xl font-titleFont tracking-widest'>
                Your Online Domination Experience
              </h3>
            </div>
            <div className='grid lg:hidden items-center'>
              <h3 className='text-3xl font-titleFont tracking-widest border-b-2 border-solid border-colour3 dark:border-colour3 pb-1 lg:border-none'>
                Your Online Domination <br /> Experience
              </h3>
            </div>
            <div className='hidden lg:grid items-center'>
              <div
                className='h-[2px] -mt-1 bg-colour3 dark:bg-colour3'
                role='separator'
                aria-hidden='true'
              ></div>
            </div>
          </section>

          {/* Main article */}
          <section className='grid gap-4 text-center lg:text-left text-sm'>
            <p>
              Online sessions are just as intense and thrilling as real-life
              encounters. With my commanding presence and psychological
              expertise, I will guide you into a world of submission where I
              dictate your pleasure, pain, and obedience. Whether you seek
              discipline, training, financial domination, or control, I will
              tailor each session to your deepest desires.
            </p>
            <p>
              Before the session begins, we will establish expectations and
              limits to ensure a safe and satisfying experience. Once our
              dynamic is set, you will surrender entirely to my control, with no
              escape until I allow it.
            </p>
            <p>
              If you are truly ready to serve and submit, follow the booking
              steps above and prepare to experience my dominance in its purest
              form, no matter where you are.
            </p>
          </section>
        </article>

        {/* Image */}
        <div className='my-auto pt-2'>
          <img
            src={GalleryImage}
            alt={`${CompanyName} displaying dominance`}
            className='mx-auto object-cover md:max-h-[60vh] rounded-xl shadow-cardShadow shadow-colour4/80 dark:shadow-colour4/80'
            loading='lazy'
          />
        </div>
      </div>
    </section>
  );
}

export default SectionTwo;
